import { render, staticRenderFns } from "./DetailOfsCatalog.vue?vue&type=template&id=58d9f84d&"
import script from "./DetailOfsCatalog.vue?vue&type=script&lang=js&"
export * from "./DetailOfsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports